import React from 'react';
import LogoPNG from './logo.png';
import * as styles from './Logo.module.css';

const Logo = () => {
  return (
    <>
      <img className={styles.Logo} src={LogoPNG} alt="" />
      <img className={styles.logoMobile} src={'/logo-mobile.png'} alt="" />
    </>
  );
};

export default Logo;
